// i18n foundation (Fase 3): today only the public site uses it (namespace «site»). The app stays Italian; to translate it later,
// add namespaces (e.g. locales/<lng>/app.json) and wrap texts with useTranslation("app").
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import it from "./locales/it/site.json";
import es from "./locales/es/site.json";
import en from "./locales/en/site.json";
import itHelp from "./locales/it/help.json";
import esHelp from "./locales/es/help.json";
import enHelp from "./locales/en/help.json";

export const LANGS = ["it", "es", "en"];
export const FALLBACK = "it";
export const HELP_LANG_KEY = "musora_help_lang";

export function detectLang() {
  const prefs = navigator.languages?.length ? navigator.languages : [navigator.language || ""];
  for (const p of prefs) {
    const code = String(p).slice(0, 2).toLowerCase();
    if (LANGS.includes(code)) return code;
  }
  return FALLBACK;
}

i18n.use(initReactI18next).init({
  resources: { it: { site: it, help: itHelp }, es: { site: es, help: esHelp }, en: { site: en, help: enHelp } },
  lng: FALLBACK,
  fallbackLng: FALLBACK,
  supportedLngs: LANGS,
  ns: ["site", "help"],
  defaultNS: "site",
  interpolation: { escapeValue: false },
  returnObjects: true,
});

export default i18n;
